/**
 * <NotYetImplemented feature="key"> — wraps a control whose backend does not
 * exist yet. While `feature` is in the registry, shows a banner and disables
 * every nested control. `inline` skips the block banner: a dashed outline,
 * a tooltip and sr-only text instead. Remove the registry entry to unlock the control.
 */
import React from 'react';
import { UNFINISHED, isUnfinished } from '../../features/unfinished';

// Browsers already block clicks inside a disabled fieldset; jsdom does not.
// Swallow them in the capture phase so behaviour is the same everywhere.
const block = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

const FIELDSET_RESET = { border: 0, padding: 0, margin: 0, minWidth: 0 };

export default function NotYetImplemented({ feature, children, registry = UNFINISHED, className, inline = false }) {
  if (!isUnfinished(feature, registry)) return <>{children}</>;
  const { label } = registry[feature];
  if (inline) {
    return (
      <fieldset
        disabled
        title={`Not yet implemented: ${label}`}
        style={{ ...FIELDSET_RESET, outline: '1.5px dashed currentColor', outlineOffset: 2 }}
        className={`text-ink ${className || ''}`}
        onClickCapture={block}
      >
        <span className="sr-only">Not yet implemented</span>
        {children}
      </fieldset>
    );
  }
  return (
    <div className={className}>
      <div
        title={label}
        className="inline-block text-xs font-semibold bg-hl-soft border border-dashed border-ink px-2 py-0.5 mb-1"
      >
        Not yet implemented
      </div>
      <fieldset disabled style={FIELDSET_RESET} onClickCapture={block}>
        {children}
      </fieldset>
    </div>
  );
}
